import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconConsoleSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconConsoleSimple"><Path fillRule="evenodd" clipRule="evenodd" d="M5.00015 5.58582L11.4144 12L5.00015 18.4142L3.58594 17L8.58594 12L3.58594 7.00003L5.00015 5.58582ZM12.0002 16H20.0002V18H12.0002V16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconConsoleSimple;
